import { LocationMapper } from "app/location/location.mapper";
import { ClientMapper } from "app/client/client.mapper";
import { ClientPotential } from "./client-potential.model";

export class ClientPotentialMapper {
  public static map(data: any): ClientPotential {
    if (!data) {
      return null;
    }

    return new ClientPotential(
      data.id,
      data.client ? ClientMapper.map(data.client) : null,
      data.transportType,
      data.loadType,
      data.volume,
      data.unitType,
      data.originCountry,
      data.originLocation ? LocationMapper.map(data.originLocation) : null,
      data.destinationCountry,
      data.destinationLocation
        ? LocationMapper.map(data.destinationLocation)
        : null,
      data.comment,
    );
  }
}
